/// <amd-module name="SuiteCommerce.FeaturedCategory.Button.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Button.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ButtonModel = /** @class */ (function (_super) {
        __extends(ButtonModel, _super);
        function ButtonModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ButtonModel.prototype, "buttonText", {
            get: function () {
                return this.get('buttonText') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ButtonModel.prototype, "buttonLink", {
            get: function () {
                return this.get('buttonLink');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ButtonModel.prototype, "customUrl", {
            get: function () {
                return this.get('customUrl');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ButtonModel.prototype, "fullurl", {
            get: function () {
                return this.get('fullurl');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ButtonModel.prototype, "buttonStyle", {
            get: function () {
                return this.get('buttonStyle');
            },
            enumerable: true,
            configurable: true
        });
        ButtonModel.prototype.updateButtonSettings = function (properties) {
            this.set(properties);
        };
        return ButtonModel;
    }(Backbone_1.Model));
    exports.ButtonModel = ButtonModel;
});
